import { RequestConfig } from '@/interface'

const PRRFIX = 'glht/lqdwxx/'
const firmConfig: RequestConfig = {
  // 绑定单位
  bddw: {
    url: `${PRRFIX}bddw`,
    method: 'post'
  },
  // 绑定单位删除
  bddwDel: {
    url: `${PRRFIX}delete`,
    method: 'get'
  },
  // 乐企单位能力信息
  lqdwNlxx: {
    url: `${PRRFIX}lqdwNlxx`,
    method: 'get'
  },
  // 乐企单位树状信息
  lqdwxxTree: {
    url: `${PRRFIX}lqdwxxTree`,
    method: 'get'
  },
  // 能力接口信息
  nljkxx: {
    url: `${PRRFIX}nljkxx`,
    method: 'get'
  },
  // queryList
  firmQueryList: {
    url: `${PRRFIX}queryList`,
    method: 'post'
  },
  // 保存乐企单位树状信息
  saveLqdwxxTree: {
    url: `${PRRFIX}saveLqdwxxTree`,
    method: 'post'
  }
}
export default firmConfig
